import React from "react";
import EADialog from '../../../components/common/EADialog';
import EAIcon from '../../../components/common/EAIcon';
import useStyles from '../../../style/js-style/containers/roadmap/RoadmapStyle';

const RoadMapItemPopUp = ({ item, onClose, isOpen, title }) => {
  const { classes } = useStyles();

  return (
    <EADialog
      isOpen={isOpen}
      onClose={onClose}
      hasActions={false}
      maxWidth="popupmd"
      fullWidth
      title={title}
    >
      <div className={classes.mainContentPopUpWrapper}>
        <div style={{ width: "100%" }}>
          {item.content}
        </div>
        {item.imageURI &&
          <div>
            <EAIcon icon={`/roadmap/preview/${item.value}`} extension={"png"} className={classes.illustration}/>
          </div>
        }
      </div>
    </EADialog>
  );
};

export default RoadMapItemPopUp;
